module.exports = __webpack_public_path__ + "static/media/calculatedAmount.d1973200.svg";